import React from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALES } from '../../i18n/locales';
import { saveUserPreferences } from '../../services/api';

type Props = {
  userId?: string;
  size?: 'small' | 'medium' | 'large';
  value?: string;
  onChange?: (val: string) => void;
};

export default function LanguageSelector({ userId, size, value, onChange }: Props) {
  const { i18n: i18 } = useTranslation();
  const current = value ?? i18.language;

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const next = e.target.value;
    if (onChange) {
      onChange(next);
      return;
    }
    await i18.changeLanguage(next);
    localStorage.setItem('userLocale', next);
    localStorage.setItem('wms-user-locale', next);
    if (userId) {
      try {
        await saveUserPreferences(userId, { language: next });
      } catch (err) {
        // eslint-disable-next-line no-console
      }
    }
  };

  return (
    <select value={current} onChange={handleChange} data-testid="language-selector">
      {LOCALES.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
    </select>
  );
}
